import React from "react";
import groupAvatar from "../assets/avatarGroup.svg";

const OurStories = () => {
  
  return (
    <div className="py-6 flex flex-col gap-6">
      {/* Section Header - Green & Gold theme */}
      <div className="text-center">
        <h2 className="text-4xl font-bold bg-gradient-to-r from-green-800 via-green-600 to-yellow-500 bg-clip-text text-transparent">
          Our Stories
        </h2>
      </div>

      {/* Story Text - Updated with green accent */}
      <div className="max-w-4xl mx-auto space-y-4 text-center">
        <p className="text-lg text-gray-700 leading-relaxed">
          At <span className="font-semibold text-green-600">IFJ</span>, we believe in creating opportunities that bridge the gap between
          talent and experience. Our platform is dedicated to connecting aspiring
          individuals with the right internships and entry-level opportunities to
          help them launch their careers.
        </p>
        
        <p className="text-lg text-gray-700 leading-relaxed">
          From our humble beginnings, we've grown into a community-driven space
          where ambition meets mentorship. Each story on our platform reflects the
          journey of passionate individuals striving to make their mark.
        </p>
        
        <p className="text-lg text-gray-700 leading-relaxed">
          Whether you're an intern looking for your first step or an employer
          searching for fresh talent, IFJ is here to make those connections
          meaningful. Together, we are shaping a future where potential is
          nurtured, and success stories are written every day.
        </p>
      </div>

      {/* Testimonial Section - Green & Gold theme */}
      <div className="bg-gradient-to-br from-white to-green-50 rounded-2xl py-16 md:px-12 px-6 border border-green-100 shadow-lg w-full">
        <div className="flex w-full xsm:flex-col gap-8">
          {/* Left Section */}
          <div className="flex md:w-1/2 w-full flex-col gap-6">
            <div className="flex md:flex-col-reverse xsm:flex-col gap-4">
              <h3 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-green-800 to-yellow-600 bg-clip-text text-transparent leading-tight">
                Turning Ambitions into Achievements
              </h3>
              <p className="text-lg text-gray-600 font-medium leading-relaxed">
                Discover inspiring journeys of individuals who started with a
                dream and found their path to success through IFJ.
              </p>
            </div>
            
            {/* Reviews Section - Green & Gold accent */}
            <div className="flex xsm:flex-col gap-4 items-center w-fit bg-gradient-to-r from-green-50 to-yellow-50 rounded-xl p-4 shadow-sm border border-green-200">
              <img src={groupAvatar} alt="User avatars" className="h-10" />
              <span className="text-green-800 font-semibold">+2 Reviews</span>
            </div>
          </div>

          {/* Right Section - Testimonial */}
          <div className="flex md:w-1/2 w-full flex-col gap-6">
            {/* Testimonial Text - Green theme */}
            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-6 border border-green-200 shadow-sm">
              <p className="text-lg text-gray-700 leading-relaxed italic">
                "IFJ made finding the right internship so easy! The platform
                connected me with opportunities that aligned perfectly with my
                career goals. I'm so grateful for the experience!"
              </p>
              <div className="mt-4 pt-4 border-t border-green-200">
                <p className="font-semibold text-green-800">Isaac Oyekunle</p>
                <p className="text-sm text-gray-600">Software Engineering Intern</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurStories;